import { defineStore } from 'pinia';
import { useLocalizationStore } from './localization';
import config from './../config';

import mlogin from '@/components/modal/modal-login/modal-login.vue';
import mregister from '@/components/modal/modal-register/modal-register.vue';
import mlostpassword from '@/components/modal/modal-lostpassword/modal-lostpassword.vue';
import mresetpassword from '@/components/modal/modal-resetpassword/modal-resetpassword.vue';
import mnew from '@/components/modal/modal-new/modal-new.vue';
import mcookie from '@/components/modal/modal-cookie/modal-cookie.vue';
import mloader from '@/components/modal/modal-loader/modal-loader.vue';
import mclose from '@/components/modal/modal-close/modal-close.vue';
import munlock from '@/components/modal/modal-unlock/modal-unlock.vue';
import mpayment from '@/components/modal/modal-payment/modal-payment.vue';
import mpaysafe from '@/components/modal/modal-paysafe/modal-paysafe.vue';
import mblockedregion from '@/components/modal/modal-blockedregion/modal-blockedregion.vue';
import mageverify from '@/components/modal/modal-ageverify/modal-ageverify.vue';

export const useModalsStore = defineStore('modals', {
    state: (): Partial<any> => ({
        modals: [
            { name: 'login', comp: mlogin, active: false, loader: true, close: true },
            { name: 'register', comp: mregister, active: false, loader: true, close: true },
            { name: 'lostpassword', comp: mlostpassword, active: false, loader: true, close: true },
            { name: 'resetpassword', comp: mresetpassword, active: false, loader: true, close: true },
            { name: 'new', comp: mnew, active: false, loader: false, close: true },
            { name: 'cookiee', comp: mcookie, active: false, loader: false, class: 'large' },
            { name: 'loader', comp: mloader, active: false, loader: false, close: false, class: 'small modals__modal-loader'},
            { name: 'close', comp: mclose, active: false, loader: false, close: true, next: undefined, class: 'small'},
            { name: 'unlock', comp: munlock, active: false, loader: false, close: false },
            { name: 'payment', comp: mpayment, active: false, loader: false, close: true },
            { name: 'paysafe', comp: mpaysafe, active: false, loader: true, close: false },
            { name: 'blockedregion', comp: mblockedregion, active: false, loader: false, close: false },
            { name: 'ageverify', comp: mageverify, active: false, loader: false, close: true }
        ]
    }),
    actions: {
        getModal(name: string) {
            const modal = this.modals.find((modal: any) => modal.name === name);
            return this.modals.find((modal: any) => modal.name === name);
        },
        async toggleModal(name: string, boolean?: boolean, next?: any) {
            this.closeAllModals();
            const modal = this.modals.find((modal: any) => modal.name === name);

            if (typeof boolean != 'undefined') {
                modal.active = boolean;
            } else {
                modal.active = !modal.active;
            }

            if (next) {
                modal.next = next;
            }
        },
        async closeModal(name: string) {
            const modal = this.modals.find((modal: any) => modal.name === name);
            modal.active = false;
            if (modal.next) {
                modal.next = undefined;
            }
        },
        async closeAllModals() {
            this.modals.map((modal: any) => (modal.active = false));
        },
        async initModals(){
            const storageName = `${config.StorageKey}.cookies`;
            const modalName = 'cookiee';
            if (!window.localStorage.hasOwnProperty(storageName)) {
                this.toggleModal(modalName);
            }
        }
    },
    getters: {
        hasActiveModals(state: any) {
            return state.modals ? state.modals.some((modal: any) => modal.active === true) : false;
        },
        getActiveModal(state: any) {
            return state.modals.find((modal: any) => modal.active === true) ? state.modals.find((modal: any) => modal.active === true).name : '';
        }
    }
});
